export const GOOGLE_SESSION_FLAG = 'ccm_google_session_established';
export const POPUP_NAME = 'rpm-impact-popup';
export const IFRAME_NAME = 'rpm-impact';
export const POPUP_FEATURES = 'width=800,height=900';

let pendingPopup = null;

export const hasEstablishedGoogleSession = () => localStorage.getItem(GOOGLE_SESSION_FLAG) === '1';

export const markGoogleSessionEstablished = () => {
    localStorage.setItem(GOOGLE_SESSION_FLAG, '1');
};

export const clearGoogleSession = () => {
    localStorage.removeItem(GOOGLE_SESSION_FLAG);
};

export const openRpmImpactPopupSync = () => {
    if (hasEstablishedGoogleSession()) {
        return null;
    }
    const popup = window.open('', POPUP_NAME, POPUP_FEATURES);
    pendingPopup = popup;
    return popup;
};

export const consumePendingPopup = () => {
    const popup = pendingPopup;
    pendingPopup = null;
    return popup;
};

export const showLoggingInSplash = (popupWindow) => {
    popupWindow.document.open();
    popupWindow.document.write(
        '<!DOCTYPE html><html><head><title>Logging into Impact</title><style>' +
        'body { font-family: sans-serif; display: flex; align-items: center; justify-content: center; height: 100vh; margin: 0; color: #333; }' +
        '</style></head><body><p>Logging into Impact&hellip;</p></body></html>'
    );
    popupWindow.document.close();
};
